import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
// import z from 'zod'

import useAddressPickerModal from '@features/address-picker/hooks/useAddressPickerModal'
import DeliveryAddressFormFields from '@features/shipping-methods/delivery/form/fields'


import Button from '@shared/ui/button'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@shared/ui/form'
import Input from '@shared/ui/input'
import Textarea from '@shared/ui/text-area'
import Wrapper from '@shared/ui/wrapper'
// import { PHONE_MASK_LENGTH } from '@shared/validation'

import styles from './styles.module.scss'


// TODO: Move to component
// const formSchema = z
//   .object({
//     apartment: z.string().optional(),
//     floor: z.string().optional(),
//     entrance: z.string().optional(),
//     intercom: z.string().optional(),
//     comment: z.string().optional(),
//     title: z.string().optional(),
//     otherBuyer: z.boolean().optional(),
//     otherBuyerName: z.string().optional(),
//     otherBuyerPhone: z.string().optional(),
//   })
//   .superRefine((data, ctx) => {
//     if (data.otherBuyer) {
//       if (!data.otherBuyerName?.trim()) {
//         ctx.addIssue({
//           path: [ 'otherBuyerName' ],
//           code: z.ZodIssueCode.custom,
//           message: 'Обязательное поле',
//         })
//       }
//       if ((data.otherBuyerPhone?.trim().length ?? 0) < PHONE_MASK_LENGTH) {
//         ctx.addIssue({
//           path: [ 'otherBuyerPhone' ],
//           code: z.ZodIssueCode.custom,
//           message: 'Неверный номер',
//         })
//       }
//     }
//   })


export default function DeliveryForm () {
  const { control } = useFormContext()
  const { t: o } = useTranslation('order')
  const { t: c } = useTranslation('common')
  const { openAddressPickerModal } = useAddressPickerModal()

  return (
    <Wrapper className={styles.root__wrapper}>
      <h3 className={styles.root__title}>{c('delivery')}</h3>
      <div className={styles.root}>
        <div className={styles.form}>
          <FormField
            control={control}
            name="address"
            render={({ field }) => (
              <FormItem className={styles.form__item}>
                <FormControl>
                  <Input
                    disabled
                    {...field}
                    placeholder={o('form.address.placeholder')}
                  />
                </FormControl>
                <Button
                  onClick={() => {
                    openAddressPickerModal()
                  }}
                  theme="primary"
                >
                  {c('change')}
                </Button>
                <FormDescription>
                  <span>{o('form.address.description')}</span>
                </FormDescription>
              </FormItem>
            )}
          />

          <DeliveryAddressFormFields control={control} noTitleInput noOtherPerson noCourierComment />

          {/* <div className={styles.form__flex}>
            {[
              {
                name: 'apartment',
                placeholder: o('form.apartment'),
                value: selectedAddress?.address_appartments,
              },
              {
                name: 'floor',
                placeholder: o('form.floor'),
                value: selectedAddress?.address_floor,
              },
              {
                name: 'entrance',
                placeholder: o('form.entrance'),
                value: selectedAddress?.address_porch,
              },
              {
                name: 'intercom',
                placeholder: o('form.intercom'),
                value: selectedAddress?.address_intercom,
              },
            ]
              .filter(({ value }) => value)
              .map(({ name, placeholder, value }) => (
                <p key={name}>
                  {placeholder}: <span>{value}</span>
                </p>
              ))}
          </div> */}

          <div className={styles.form__grid}>
            <FormField
              control={control}
              name="comment"
              render={({ field }) => (
                <FormItem className={styles.form__comment}>
                  <FormControl>
                    <Textarea
                      {...field}
                      placeholder={o('form.comment-delivery')}
                      className={styles.textarea}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          {/* <div className={styles.form__options}>
            {[
              { name: 'noIntercomCall', label: o('form.noIntercomCall') },
              { name: 'leaveAtDoor', label: o('form.leaveAtDoor') },
            ].map(({ name, label }) => (
              <FormField
                key={name}
                control={control}
                name={name as string}
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <Checkbox
                        checked={!!field.value}
                        onChange={field.onChange}
                        label={label}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
            ))}
          </div> */}
        </div>
      </div>
    </Wrapper>
  )
}
